export const en = {
    'accept-button': 'Allow impressions',
    'many-pages-title': 'Allow impressions on {count} quality ad platforms',
    'one-page-title': 'Allow impressions on {count} quality ad platform',
    'simple-progress-hint': 'Allowing impressions on quality ad platforms',
    'some-pages-title': 'Allow impressions on {count} quality ad platforms',
    'title-hint':
        'The recommendation is shown because you have high-quality click-generating sites in your list of blocked sites'
};
